import { createSelector } from "reselect";
const getHotels = state => state.hotels.data;
const getSelectedHotelId = state => state.hotels.selected;

export const getSelectedHotel = createSelector(
  [getHotels, getSelectedHotelId],
  (hotels, hotelId) => hotels.find(hotel => hotel.hotelId === hotelId)
);

export const getSelectedHotelMappedId = createSelector(
  [getSelectedHotel],
  selectedHotel =>
    selectedHotel.hotelMapping && selectedHotel.hotelMapping.hotelMapId
);

export const getSyncedHotels = createSelector([getHotels], hotels =>
  hotels.filter(hotel => hotel.hotelMapping != undefined)
);



// WEBPACK FOOTER //
// ./src/hotels/selectors.js